import { useEffect } from 'react';

import { growthBookInstance } from '~shared/growthbook';

import * as Sentry from '@breeze/web-lib-sentry';
import Clarity from '@microsoft/clarity';

import { getAnalyticsUserPermissions } from './analytics-user';

import type { Permission } from '../entities/permissions';
import type { UserInfo } from '../model';

export const useIdentifyUser = (
  userInfo?: UserInfo,
  permissions?: Permission[]
) => {
  useEffect(() => {
    if (userInfo?.personId) {
      Clarity.setTag('person_id', userInfo.personId);
      Clarity.setTag('role', getAnalyticsUserPermissions(permissions ?? []));
      Sentry.setTag('personId', userInfo.personId);
      growthBookInstance.updateAttributes({
        personId: userInfo.personId,
      });
    }
  }, [userInfo, permissions]);
};
